export type MerchProductCategory =
  | 'jersey'
  | 'hoodie'
  | 'cap'
  | 'polo'
  | 'jogger'
  | 'accesorio'
  | 'other';

export type MerchSize = 'XS' | 'S' | 'M' | 'L' | 'XL' | 'XXL' | 'XXXL' | 'Único';

export interface SizeChartEntry {
  label: string;
  chest?: number;
  waist?: number;
  length?: number;
  hip?: number;
}

export interface MerchSizeChart {
  sizes: SizeChartEntry[];
}

export interface MerchOrganization {
  id: string;
  name: string;
  slug: string;
  logo_url?: string;
  primary_color?: string;
  secondary_color?: string;
  instagram?: string;
  x?: string;
  twitch?: string;
  kick?: string;
  tiktok?: string;
}

export interface MerchProductImage {
  id: string;
  product_id: string;
  url: string;
  display_order: number;
  is_primary: boolean;
}

export interface MerchProductVariant {
  id: string;
  product_id: string;
  size: string;
  stock_quantity: number;
  is_available: boolean;
}

export interface MerchProductDetails {
  product_id: string;
  category?: MerchProductCategory | string;
  material?: string;
  care_instructions?: string;
  size_chart?: MerchSizeChart;
  is_featured: boolean;
}

export interface MerchProduct {
  id: string;
  organization_id: string;
  name: string;
  description?: string;
  price: number;
  stock_quantity: number;
  image_url?: string;
  is_active: boolean;
  is_merch: boolean;
  images?: MerchProductImage[];
  variants?: MerchProductVariant[];
  details?: MerchProductDetails | null;
}

export interface PublicMerchStore {
  organization: MerchOrganization;
  products: MerchProduct[];
}

export interface PublicMerchProductDetail {
  organization: MerchOrganization;
  product: MerchProduct;
}

export interface MerchCheckoutDto {
  product_id: string;
  quantity?: number;
  selected_size?: string;
  buyer_email: string;
  buyer_name?: string;
}

export interface MerchCheckoutResponse {
  order: {
    id: string;
    status: string;
    amount: number;
  };
  init_point: string;
  sandbox_init_point?: string;
}

export interface MerchOrder {
  id: string;
  organization_id: string;
  product_id: string;
  quantity: number;
  selected_size?: string;
  buyer_email: string;
  buyer_name?: string;
  status: string;
  amount: number;
  currency: string;
  created_at: string;
  product_name?: string;
  product_image_url?: string;
}

export interface MerchVariantInput {
  size: string;
  stock_quantity: number;
  is_available?: boolean;
}

export interface UpdateMerchDetailsDto {
  category?: string;
  material?: string;
  care_instructions?: string;
  size_chart?: MerchSizeChart;
  is_featured?: boolean;
}

export interface OrgPaymentSettings {
  mp_public_key?: string | null;
  has_access_token: boolean;
  has_webhook_secret: boolean;
  webhook_url?: string | null;
  back_url?: string | null;
}

export interface UpdatePaymentSettingsDto {
  mp_public_key?: string;
  mp_access_token?: string;
  mp_webhook_secret?: string;
}

export const MERCH_SIZES: MerchSize[] = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'Único'];

export const MERCH_CATEGORIES: { value: MerchProductCategory; label: string }[] = [
  { value: 'jersey', label: 'Jersey' },
  { value: 'hoodie', label: 'Hoodie' },
  { value: 'cap', label: 'Gorra' },
  { value: 'polo', label: 'Polo' },
  { value: 'jogger', label: 'Jogger' },
  { value: 'accesorio', label: 'Accesorio' },
  { value: 'other', label: 'Otro' },
];
